import React from 'react';
import { API_BASE, toUrl } from '../lib/config';

type Section = {
  id: string;
  titleLight?: string | null;
  titleAccent?: string | null;
  description?: string | null;
  isActive: boolean;
  updatedAt: string;
};

const FeedbackSectionYonetim: React.FC = () => {

  const [sections, setSections] = React.useState<Section[]>([]);
  const [selectedId, setSelectedId] = React.useState<string>('');
  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState('');

  const [titleLight, setTitleLight] = React.useState('');
  const [titleAccent, setTitleAccent] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [isActive, setIsActive] = React.useState(true);
  const [toast, setToast] = React.useState<{ show: boolean; text: string }>({ show: false, text: '' });

  const fetchAll = React.useCallback(async () => {
    try {
      setLoading(true); setError('');
      const res = await fetch(toUrl('/api/feedback-section/admin'));
      if (!res.ok) throw new Error('Kayıtlar alınamadı');
      const data = await res.json();
      setSections(data || []);
      const initial = (data && data[0]) || null;
      if (initial) {
        setSelectedId(initial.id);
        setTitleLight(initial.titleLight || '');
        setTitleAccent(initial.titleAccent || '');
        setDescription(initial.description || '');
        setIsActive(!!initial.isActive);
      }
    } catch (e: any) { setError(e.message || 'Beklenmeyen bir hata oluştu'); }
    finally { setLoading(false); }
  }, []);

  React.useEffect(() => { fetchAll(); }, [fetchAll]);

  const onChangeSelection = (id: string) => {
    setSelectedId(id);
    const s = sections.find(x => x.id === id);
    if (s) {
      setTitleLight(s.titleLight || '');
      setTitleAccent(s.titleAccent || '');
      setDescription(s.description || '');
      setIsActive(!!s.isActive);
    }
  };

  const onSave = async () => {
    if (!selectedId) { setError('Düzenlenecek kayıt bulunamadı'); return; }
    try {
      setSaving(true); setError('');
      const body: any = {
        titleLight: titleLight || null,
        titleAccent: titleAccent || null,
        description: description || null,
        isActive: !!isActive,
      };
      const res = await fetch(toUrl(`/api/feedback-section/admin/${selectedId}`), { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (!res.ok) throw new Error('Güncelleme başarısız');
      await fetchAll();
      setToast({ show: true, text: 'Başarılı' });
      window.setTimeout(() => setToast({ show: false, text: '' }), 2000);
    } catch (e: any) { setError(e.message || 'Beklenmeyen bir hata oluştu'); }
    finally { setSaving(false); }
  };

  return (
    <div className="admin-page" style={{ padding: 12 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 12 }}>
        <h2 style={{ margin: 0 }}>Feedback Section</h2>
        <div style={{ fontSize: 12, color: '#6b7280' }}>Kayıt: {sections.length}</div>
      </div>

      <div className="card" style={{ padding: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <div style={{ fontWeight: 600 }}>Alanlar</div>
          <button onClick={fetchAll} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', color: '#374151', cursor: 'pointer' }}>Yenile</button>
        </div>

        {sections.length > 1 && (
          <div style={{ marginBottom: 16 }}>
            <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Kayıt Seç</label>
            <select className="input" value={selectedId} onChange={(e) => onChangeSelection(e.target.value)}>
              {sections.map(s => (
                <option key={s.id} value={s.id}>{s.titleLight || s.titleAccent || s.id}</option>
              ))}
            </select>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div style={{ display: 'grid', gap: 6 }}>
            <label className="form-label">Açık Başlık (titleLight)</label>
            <input className="input" value={titleLight} onChange={(e) => setTitleLight(e.target.value)} />
          </div>
          <div style={{ display: 'grid', gap: 6 }}>
            <label className="form-label">Vurgulu Başlık (titleAccent)</label>
            <input className="input" value={titleAccent} onChange={(e) => setTitleAccent(e.target.value)} />
          </div>
          <div style={{ display: 'grid', gap: 6, gridColumn: '1 / -1' }}>
            <label className="form-label">Açıklama</label>
            <textarea className="input" rows={5} value={description} onChange={(e) => setDescription(e.target.value)} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input id="act" type="checkbox" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
            <label htmlFor="act">Aktif</label>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16, gap: 8 }}>
          <button onClick={onSave} disabled={saving || !selectedId} style={{ padding: '10px 16px', borderRadius: 8, border: '1px solid #16a34a', background: '#16a34a', color: '#fff', cursor: 'pointer', opacity: saving ? 0.8 : 1 }}>{saving ? 'Kaydediliyor...' : 'Kaydet'}</button>
        </div>

        {error && <div style={{ marginTop: 8, color: '#b00020' }}>{error}</div>}
      </div>

      {toast.show && (
        <div role="status" aria-live="polite" style={{ position: 'fixed', right: 16, bottom: 16, background: '#16a34a', color: '#fff', padding: '10px 14px', borderRadius: 8, boxShadow: '0 10px 20px rgba(0,0,0,0.15)' }}>
          {toast.text}
        </div>
      )}
    </div>
  );
};

export default FeedbackSectionYonetim;
